module.exports = __webpack_public_path__ + "static/media/behadrei.298de25b.png";